/* eslint-disable react-hooks/exhaustive-deps */
import Title from "../SmallComponents/Title";
import { useContext, useState, useEffect } from "react";
import { ShopContext } from "../Context/ShopContext";
import axios from "axios";
import { toast } from "react-toastify";

const OrdersPage = () => {
  const { backendUrl, token, currency } = useContext(ShopContext);

  const [orderData, setOrderData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortType, setSortType] = useState("newest");

  const ordersPerPage = 8;

  const totalPages = Math.ceil(orderData.length / ordersPerPage);

  // Get the orders to display on the current page
  const indexOfLastOrder = currentPage * ordersPerPage;
  const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
  const currentOrders = orderData.slice(indexOfFirstOrder, indexOfLastOrder);

  console.log(orderData);

  const loadOrderData = async () => {
    try {
      if (!token) {
        return null;
      }

      const response = await axios.post(
        backendUrl + `/api/order/userorders`,
        {},
        { headers: { token } }
      );
      // console.log(response.data);

      if (response.data.success) {
        let allOrdersItem = [];
        response.data.orders.map((order) => {
          order.items.map((item) => {
            item["status"] = order.status;
            item["payment"] = order.payment;
            item["paymentMethod"] = order.paymentMethod;
            item["date"] = order.date;
            allOrdersItem.push(item);
          });
        });

        // console.log(allOrdersItem);
        setOrderData(allOrdersItem.reverse());
      }
    } catch (error) {
      console.log(error);
      toast.error("Error fetching orders");
    }
  };

  // Sorting Logic
  const sortOrders = (orders, type) => {
    let sorted = [...orders];

    switch (type) {
      case "newest":
        sorted.sort((a, b) => new Date(b.date) - new Date(a.date));
        break;
      case "oldest":
        sorted.sort((a, b) => new Date(a.date) - new Date(b.date));
        break;
      case "priceHigh":
        sorted.sort((a, b) => b.price - a.price);
        break;
      case "priceLow":
        sorted.sort((a, b) => a.price - b.price);
        break;
      default:
        break;
    }

    return sorted;
  };

  useEffect(() => {
    loadOrderData();
  }, [token]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setOrderData((prevData) => sortOrders(prevData, sortType));
  }, [currentPage, sortType]);

  return (
    <div className=" pt-16">
      <div className="px-2 ">
        <div className="text-2xl">
          <Title text1={"My"} text2={"Orders"} />
        </div>

        <div>
          <div className="flex justify-end mb-6">
            <select
              value={sortType}
              onChange={(e) => setSortType(e.target.value)}
              className="border px-4 py-2 text-sm rounded-sm bg-white text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-gray-800"
            >
              <option value="newest">Sort by Newest</option>
              <option value="oldest">Sort by Oldest</option>
              <option value="priceHigh">Price: High to Low</option>
              <option value="priceLow">Price: Low to High</option>
            </select>
          </div>

          {currentOrders.map((item, index) => (
            <div
              key={index}
              className="py-4 border-t border-b text-gray-700 flex flex-col md:flex-row md:items-center md:justify-between gap-4"
            >
              <div className="flex items-start gap-6  text-sm">
                <img
                  className="w-16 sm:w-20"
                  src={item.images[0]}
                  alt="image"
                />
                <div>
                  <p className="sm:text-base font-medium">{item.name}</p>
                  <div className="flex flex-col  gap-3 lg:gap-2 mt-2 text-base text-gray-700">
                    <p className="text-lg text-nowrap font-semibold text-green-600">
                      {currency} {item.price}
                    </p>
                    <p className="text-nowrap ">
                      <span className="font-semibold">Quantity:</span>{" "}
                      {item.quantity}
                    </p>
                    <p className="text-nowrap">
                      <span className="font-semibold">Size:</span> {item.size}
                    </p>
                  </div>
                </div>
                <p className="mt-1">
                  Date: <br />{" "}
                  <span className="text-gray-400 md:text-nowrap">
                    {new Date(item.date).toDateString()}
                  </span>
                </p>
                <p className="mt-1">
                  Payment:{" "}
                  <span className="text-gray-400">{item.paymentMethod}</span>
                </p>
              </div>

              <div className="md:w-1/2 flex justify-between">
                <div className="flex items-center gap-2">
                  <p className="min-w-2 h-2 rounded-full bg-green-500"></p>
                  <p className="text-sm md:text-base">{item.status}</p>
                </div>
                <button
                  onClick={loadOrderData}
                  className="border px-4 py-2 text-sm font-medium rounded-sm"
                >
                  Track Order
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Pagination Buttons-Dynamic */}
        {totalPages > 1 && (
          <div className="flex justify-center mt-10 space-x-2">
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              className={`px-4 py-2 border rounded-md text-sm ${
                currentPage === 1
                  ? "text-gray-400 border-gray-300"
                  : "text-black hover:bg-gray-200"
              }`}
            >
              Previous
            </button>

            {[...Array(totalPages)].map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentPage(index + 1)}
                className={`px-4 py-2 border rounded-md text-sm ${
                  currentPage === index + 1
                    ? "bg-black text-white"
                    : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                }`}
              >
                {index + 1}
              </button>
            ))}

            <button
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages}
              className={`px-4 py-2 border rounded-md text-sm ${
                currentPage === totalPages
                  ? "text-gray-400 border-gray-300"
                  : "text-black hover:bg-gray-200"
              }`}
            >
              Next
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default OrdersPage;
